import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    height: '15px',
    width: '15px',
    marginRight: '18px',
  },
}));

export const SelectLoader: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress color="inherit" size={15} />
    </div>
  );
};
